<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-4">Set Password</h3>
      <ResetPasswordForm />
    </div>
  </b-container>
</template>

<script>
import ResetPasswordForm from '../../components/Forms/ResetPasswordForm'

export default {
  name: 'AdminResetPassword',
  components: { ResetPasswordForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/AdminResetPassword.vue?01693027